import React, { useState } from 'react';
import {
    Typography,
    Button,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import { LinkedIn, GitHub, Instagram, Email } from '@mui/icons-material';

const Footer = () => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Typography
                variant="body2"
                fontSize="1rem"
                sx={{ display: "block", backgroundColor: "#1976d2", color: "white" }}
            >
                © 2022 Created by Aden Tran.
            </Typography>

            <Typography
                variant="body2"
                fontSize="1rem"
                sx={{ display: "block", backgroundColor: "#1976d2", color: "white" }}
            >
                <Tooltip title="GitHub">
                    <Button sx={{ m: 0, p: 0, minWidth: "2rem" }} onClick={() => window.open("https://github.com/adeziio")}>
                        <GitHub sx={{ color: "white" }} />
                    </Button>
                </Tooltip>

                <Tooltip title="LinkedIn">
                    <Button sx={{ m: 0, p: 0, minWidth: "2rem" }} onClick={() => window.open("https://www.linkedin.com/in/aden-tran-aba695171")}>
                        <LinkedIn sx={{ color: "white" }} />
                    </Button>
                </Tooltip>

                <Tooltip title="Instagram">
                    <Button sx={{ m: 0, p: 0, minWidth: "2rem" }} onClick={() => window.open("https://www.instagram.com/adeziio")}>
                        <Instagram sx={{ color: "white" }} />
                    </Button>
                </Tooltip>

                <Tooltip title="Email">
                    <Button sx={{ m: 0, p: 0, minWidth: "2rem" }} onClick={() => window.open("mailto:adeziio@yahoo.com")}>
                        <Email sx={{ color: "white" }} />
                    </Button>
                </Tooltip>
            </Typography>

            {/* Privacy Policy link */}
            <Typography
                variant="body2"
                fontSize="0.8rem"
                sx={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    textAlign: "center",
                    paddingBottom: "0.5rem"
                }}
            >
                <Button
                    onClick={handleOpen}
                    sx={{ color: "white", textTransform: "none" }}
                >
                    Privacy Policy
                </Button>
            </Typography>

            {/* Privacy Policy Dialog */}
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Privacy Policy</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2">
                        We value your privacy. By using this website, you acknowledge and agree
                        that we collect and store certain personal information, including your
                        username, password, and email address, for the purpose of providing and
                        maintaining our services.
                        <br /><br />
                        Passwords are securely hashed and encrypted in our database and are never
                        stored in plain text. While we take reasonable measures to protect your
                        data, we cannot guarantee absolute security.
                        <br /><br />
                        You are responsible for maintaining the confidentiality of your account
                        credentials.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Footer;
